import { createStore } from "vuex";
import auth from "@/modules/auth/store";
import locales from "@/modules/locales/store";
import reports from "@/modules/reports/store";
import users from "@/modules/users/store";
import forge from "@/modules/forge/store";
import notifications from "@/modules/notifications/store";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    locales,
    reports,
    users,
    forge,
    notifications,
  },
});
